import { render, staticRenderFns } from "./importacionArchivo.vue?vue&type=template&id=706e94fa"
import script from "./importacionArchivo.vue?vue&type=script&lang=js"
export * from "./importacionArchivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports